import { render, staticRenderFns } from "./activeTeamChatHeader.vue?vue&type=template&id=1ed387a5&"
import script from "./activeTeamChatHeader.vue?vue&type=script&lang=js&"
export * from "./activeTeamChatHeader.vue?vue&type=script&lang=js&"
import style0 from "./activeTeamChatHeader.vue?vue&type=style&index=0&id=1ed387a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports